import LoyaltyPageV3 from './LoyaltyPageV3';

export default LoyaltyPageV3;
